var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YunoAPM',{attrs:{"data":[_vm.$route.params.paymentMethodType, _vm.$route.params.idSessionHash]}})
}
var staticRenderFns = []

export { render, staticRenderFns }